import React, { useState } from 'react';
import { Button } from './Button';
import { CheckCircleIcon } from 'lucide-react';
export function ContactForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  if (isSubmitted) {
    return <div className="bg-white p-8 rounded-2xl shadow-sm border border-navy-50 text-center h-full flex flex-col items-center justify-center min-h-[400px]" role="status" aria-live="polite" data-id="element-80">
        <div className="w-16 h-16 bg-green-100 text-green-500 rounded-full flex items-center justify-center mb-6" data-id="element-81">
          <CheckCircleIcon className="w-8 h-8" data-id="element-82" />
        </div>
        <h3 className="text-2xl font-bold text-navy-900 mb-2" data-id="element-83">Message Sent!</h3>
        <p className="text-navy-600 mb-8" data-id="element-84">
          Thank you for reaching out. One of our team members will get back to
          you shortly.
        </p>
        <Button variant="secondary" onClick={() => setIsSubmitted(false)} data-id="element-85">
          Send Another Message
        </Button>
      </div>;
  }
  return <form onSubmit={handleSubmit} data-component="COMP-08-ContactForm" className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-navy-50" aria-label="Contact form" data-id="element-86">
      <div className="space-y-6" data-id="element-87">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-88">
          <div data-id="element-89">
            <label htmlFor="firstName" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-90">
              First Name
            </label>
            <input type="text" id="firstName" required aria-required="true" className="w-full px-4 py-3 rounded-xl border border-navy-200 focus:ring-2 focus:ring-gold-500 focus:border-gold-500 outline-none transition-all bg-navy-50/50 focus:bg-white" placeholder="John" data-id="element-91" />
          </div>
          <div data-id="element-92">
            <label htmlFor="lastName" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-93">
              Last Name
            </label>
            <input type="text" id="lastName" required aria-required="true" className="w-full px-4 py-3 rounded-xl border border-navy-200 focus:ring-2 focus:ring-gold-500 focus:border-gold-500 outline-none transition-all bg-navy-50/50 focus:bg-white" placeholder="Smith" data-id="element-94" />
          </div>
        </div>

        <div data-id="element-95">
          <label htmlFor="email" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-96">
            Email Address
          </label>
          <input type="email" id="email" required aria-required="true" className="w-full px-4 py-3 rounded-xl border border-navy-200 focus:ring-2 focus:ring-gold-500 focus:border-gold-500 outline-none transition-all bg-navy-50/50 focus:bg-white" placeholder="john@example.com" data-id="element-97" />
        </div>

        <div data-id="element-98">
          <label htmlFor="subject" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-99">
            Subject
          </label>
          <select id="subject" required aria-required="true" className="w-full px-4 py-3 rounded-xl border border-navy-200 focus:ring-2 focus:ring-gold-500 focus:border-gold-500 outline-none transition-all bg-navy-50/50 focus:bg-white appearance-none" data-id="element-100">
            <option value="" data-id="element-101">Select an enquiry type</option>
            <option value="general" data-id="element-102">General Enquiry</option>
            <option value="schools" data-id="element-103">Schools & Education</option>
            <option value="workshops" data-id="element-104">Workshops & Events</option>
            <option value="partnerships" data-id="element-105">Partnerships</option>
          </select>
        </div>

        <div data-id="element-106">
          <label htmlFor="message" className="block text-sm font-bold text-navy-900 mb-2" data-id="element-107">
            Message
          </label>
          <textarea id="message" rows={4} required aria-required="true" className="w-full px-4 py-3 rounded-xl border border-navy-200 focus:ring-2 focus:ring-gold-500 focus:border-gold-500 outline-none transition-all bg-navy-50/50 focus:bg-white resize-none" placeholder="How can we help you?" data-id="element-108"></textarea>
        </div>

        <Button type="submit" variant="primary" className="w-full" data-id="element-109">
          Send Message
        </Button>
      </div>
    </form>;
}